import React from 'react'
import { Box, Grid, Typography } from '@mui/material';


const NoticeView = ({ notice }) => {
    return (
        <Box sx={{ mt: 1, px: 2 }}>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
            >
                <Grid item xs={1}>
                    <Typography variant="subtitle2" component="div" >제목</Typography>
                </Grid>
                <Grid item xs={11}>
                    <Typography variant="body2" component="div" >{notice?.wrTitle}</Typography>
                </Grid>
            </Grid>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
            >
                <Grid item xs={1}>
                    <Typography variant="subtitle2" component="div" >내용</Typography>
                </Grid>
                <Grid item xs={11}>
                    <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2" component="div">{notice?.wrContent}</Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default NoticeView